import { PATIENT_REFILL_ROUTE } from '@/routes/route-paths';
import { Box, IconButton, Typography } from '@montugroup/design-system';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import { useNavigate } from 'react-router-dom';

export function BackButton({ action }: { action?: () => void }) {
  const navigate = useNavigate();
  const defaultAction = () => navigate({ pathname: PATIENT_REFILL_ROUTE });

  return (
    <Box sx={{ marginBottom: 4, alignItems: 'flex-start', width: '100%' }}>
      <IconButton
        size="small"
        sx={{
          padding: 0,
          '&.MuiButtonBase-root:focus': { outline: 'none' },
        }}
        onClick={action || defaultAction}
        disableRipple
      >
        <ChevronLeft /> &nbsp;
        <Typography variant="body2" sx={(theme) => ({ color: theme.palette.primary.main })}>
          Back
        </Typography>
      </IconButton>
    </Box>
  );
}
